import './RateNotification.scss';
import {AbstractNotificationComponent, AbstractNotificationComponentScope} from "../AbstractNotificationComponent";

interface RateNotificationScope extends AbstractNotificationComponentScope {

}

export class RateNotification extends AbstractNotificationComponent {

    static instance = {
        template: require('./RateNotification.html'),
        controller: ['$scope', '$location', RateNotification],
        bindings: {
            notification: '<'
        }
    };

}